import React, { useState, useEffect, forwardRef } from 'react';

import Textarea from 'components/partials/textarea/textarea';

interface GeneratingTextareaProps {
  loading?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  [key: string]: unknown;
}

const GeneratingTextarea = forwardRef<HTMLTextAreaElement, GeneratingTextareaProps>(
  ({ loading, value, onChange, ...props }, ref) => {
    const [placeholder, setPlaceholder] = useState('');

    useEffect(() => {
      if (loading) {
        setPlaceholder('Generating');
        let dots = '';
        const interval = setInterval(() => {
          dots = dots.length < 3 ? dots + '.' : '';
          setPlaceholder(`Generating${dots}`);
        }, 500);

        return () => clearInterval(interval);
      } else {
        setPlaceholder('Generate the text by clicking the button below...');

        return undefined;
      }
    }, [loading]);

    const handleChange = (newValue: string): void => {
      if (!loading && typeof onChange === 'function') {
        (onChange as (value: string) => void)(newValue);
      }
    };

    return (
      <Textarea
        {...props}
        ref={ref}
        value={loading ? '' : (value as string) || ''}
        onChange={handleChange}
        placeholder={placeholder}
      />
    );
  }
);

export default GeneratingTextarea;
